export default "__VITE_ASSET__zhX$AgMY__"